import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";

export const AdminSessionDialog = ({
  open,
  onOpenChange,
  editingSession,
  sessionForm,
  setSessionForm,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{editingSession ? "Edit Session" : "Create New Session"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label htmlFor="title">Session Title *</Label>
            <Input
              id="title"
              required
              value={sessionForm.title}
              onChange={(e) => setSessionForm({...sessionForm, title: e.target.value})}
              placeholder="e.g., Spring 2026 Parenting Class"
              className="mt-1"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="start_date">Start Date *</Label>
              <Input
                id="start_date"
                type="date"
                required
                value={sessionForm.start_date}
                onChange={(e) => setSessionForm({...sessionForm, start_date: e.target.value})}
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="end_date">End Date *</Label>
              <Input
                id="end_date"
                type="date"
                required
                value={sessionForm.end_date}
                onChange={(e) => setSessionForm({...sessionForm, end_date: e.target.value})}
                className="mt-1"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="day_of_week">Day of Week *</Label>
              <Select
                value={sessionForm.day_of_week}
                onValueChange={(value) => setSessionForm({...sessionForm, day_of_week: value})}
              >
                <SelectTrigger className="mt-1">
                  <SelectValue placeholder="Select day" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Monday">Monday</SelectItem>
                  <SelectItem value="Tuesday">Tuesday</SelectItem>
                  <SelectItem value="Wednesday">Wednesday</SelectItem>
                  <SelectItem value="Thursday">Thursday</SelectItem>
                  <SelectItem value="Friday">Friday</SelectItem>
                  <SelectItem value="Saturday">Saturday</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label htmlFor="time">Time *</Label>
              <Input
                id="time"
                required
                value={sessionForm.time}
                onChange={(e) => setSessionForm({...sessionForm, time: e.target.value})}
                placeholder="e.g., 6:00 PM - 8:00 PM"
                className="mt-1"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="location">Location *</Label>
              <Input
                id="location"
                required
                value={sessionForm.location}
                onChange={(e) => setSessionForm({...sessionForm, location: e.target.value})}
                placeholder="e.g., Baltimore Office"
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="max_capacity">Max Capacity</Label>
              <Input
                id="max_capacity"
                type="number"
                min="1"
                value={sessionForm.max_capacity}
                onChange={(e) => setSessionForm({...sessionForm, max_capacity: parseInt(e.target.value) || 15})}
                className="mt-1"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="notes">Notes</Label>
            <Textarea
              id="notes"
              value={sessionForm.notes}
              onChange={(e) => setSessionForm({...sessionForm, notes: e.target.value})}
              placeholder="Any additional notes..."
              className="mt-1"
            />
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" className="bg-warm-700 hover:bg-warm-800">
              {editingSession ? "Update Session" : "Create Session"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
